(ns hypnos.dme.subs
  "Subscriptions for the DME application."
  (:require [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Auth

(rf/reg-sub
 :dme/auth
 (fn [db [_]]
   (get-in db [:auth])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; UI

(rf/reg-sub
 :dme/active-panel
 (fn [db _]
   (get-in db [:ui :active-panel])))

(rf/reg-sub
 :dme/aside
 (fn [db _]
   (get-in db [:ui :aside])))

(rf/reg-sub
 :dme/gql-request-in-progress?
 (fn [db _]
   (get-in db [:ui :loading?])))

(rf/reg-sub
 :dme/communication
 (fn [db _]
   (get-in db [:communication])))

(rf/reg-sub
 :dme/error
 (fn [db _]
   (get-in db [:error])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Catalog

(rf/reg-sub
 :dme/catalog
 (fn [db _]
   (get-in db [:catalog])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Consult(s)

(rf/reg-sub
 :dme/consults
 (fn [db _]
   (get-in db [:consults])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Patient(s)

(rf/reg-sub
 :dme/patients-query
 (fn [db _]
   (get-in db [:patients :query])))

(rf/reg-sub
 :dme/patient
 (fn [db _]
   (get-in db [:patient])))

(rf/reg-sub
 :dme/patients
 (fn [db _]
   (get-in db [:patients])))

(rf/reg-sub
 :dme/recommendations-with-note
 (fn [db _]
   (get-in db [:recommendations-with-note])))

(rf/reg-sub
 :dme/referral
 (fn [db _]
   (get-in db [:referral])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Organization

(rf/reg-sub
 :dme/organization
 (fn [db _]
   (get-in db [:organization])))

(rf/reg-sub
 :dme/user
 (fn [db [_]]
   (get-in db [:auth :user])))
